import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { loadTransactionDetails } from '../../../redux-flow/actions/wallet_transactions'
import { Link } from 'react-router-dom'
import Navbar from '../../../Components/Navbar'
import Footer from '../../../Components/Footer'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import '../BrlDepResWallet/brlDepRes.css'
import { Button, Icon, Skeleton } from 'antd'
import { ReactComponent as Check } from '../../../images/wallet/check.svg'
import { ReactComponent as Falha } from '../../../images/wallet/falha.svg'
import { ReactComponent as Clock } from '../../../images/wallet/clock.svg'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import moment from 'moment'
// import LoginWallet from '../loginWallet'
import Favorecido from './favorecido'
import { request } from '../../../utils/api'

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class DetalhesTransacao extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {
        type: new URLSearchParams(window.location.search).get('type'),
        status: new URLSearchParams(window.location.search).get('status'),
        loading: false,
        req: false,
        comprovante: false,
    }}

    formatarMoeda = (valor, type = 'all') => {  
        if(type === 'totalConvertido') {
            valor = valor/1
        }
        if(valor < 1) {
            valor = valor.replace('.', ',')
        } else {
            valor = valor + '';
            valor = parseInt(valor.replace(/[\D]+/g,''));
            valor = valor + '';
            valor = valor.replace(/([0-9]{2})$/g, ",$1");
            if (valor.length > 6) {
              valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
            }
        }
        
      
        if(valor[0] === ',') {
            valor = 0+valor
        }

        return valor
      }


    returnIcon = (type, status) => {
        if(type === '1') {
            if(status) {
                return (<Check className="iconDetalhe" />)
            } else {
                return (<Clock className="iconDetalhe" />)
            }
        } else if(type === '2' || type === '3') {
            if(status === 1 || status === 2) {
                return (<Falha className="iconDetalhe" />)
            } else {
                return (<Check className="iconDetalhe" />)
            }
        } else if(type === '4') {
            return (<Check className="iconDetalhe" />)
        } else if(type === '5') {
            return (<Check className="iconDetalhe" />)
        } else {
            if(status) {
                return (<Check className="iconDetalhe" />)
            } else {
                return (<Clock className="iconDetalhe" />)
            }
        }
    }

    returnMessage = (type, status) => {
        if(type === '1') {
            if(status) {
                return 'Valor enviado com sucesso'
            } else {
                return 'Aguardando confirmação da rede'
            }
        } else if(type === '2' || type === '3') {
            if(status === 1 || status === 2) {
                return 'Erro ao converter valor'
            } else {
                return 'Valor convertido com sucesso'
            }
        } else if(type === '4') {
            return 'Valor recebido com sucesso'
        } else if(type === '5') {
            return 'Valor enviado com sucesso'
        } else {
            if(status) {
                return 'Valor recebido com sucesso'
            } else {
                return 'Recebimento pendente'
            }
        }
        
    }

    returnValue = (type, details) => {
        if(type === '1' || type === '3' || type === '6') {
            return (<h2 className="tx-pink amount">{parseFloat(details.quantiaBTC).toFixed(8)}<span className="tx-blue mr-2"> BTC</span></h2>)
        } else {
            return (<h2 className="tx-pink amount"><span className="tx-blue mr-2">R$ </span>{this.formatarMoeda(parseFloat(details.quantiaBRL/100).toFixed(2))}</h2>)
        } 
    }


    componentDidMount() {
        const id = new URLSearchParams(window.location.search).get('id')
        const { onLoad, userid, loadUser, idWallet, walletLogged } = this.props
        if( userid && loadUser) {
            loadUser(userid)
        }
        this.setState({
            loading: true
        })
        if(walletLogged){
            onLoad(id, this.state.type, idWallet)
        }
        this.setState({
            loading: false,
        })
    }

    componentDidUpdate(prevState, prevProps) {
        const { walletLogged, statement, userid, onLoad, onLogged, idWallet } = this.props
        const id = new URLSearchParams(window.location.search).get('id')
        if(walletLogged && !this.state.req) {
            onLoad(id, this.state.type, idWallet)
        }
        if(walletLogged){
            this.setState({
                req: true
            })
        }
    }

    generateReceipt = async (e) => {
        try {
            this.setState({ comprovante: true})
            const response = await request('wallet/getReceipt/', 'POST', {
                nome: e.name,
                documento: e.document,
                instituicao: e.bankName,
                tipoConta: e.accountType === "CHECKING_ACCOUNT" ? 'Conta Corrente' : 'Conta Poupança',
                valor: this.formatarMoeda(e.amount),
                transactionId: e.id,
                date: moment(e.date).format("DD/MM/YYYY HH:mm:ss"),
                type: 'brl',
                agencia: e.branch,
                conta: e.account,
                digito: e.accountDigit
            })
            if (response.code === 51) {
                let link = document.createElement('a')
                link.id = 'download-file'
                link.setAttribute('href', response.path);
                link.setAttribute('download', response.name);
                document.body.appendChild(link)
                document.querySelector('#download-file').click()
                document.getElementById('download-file').remove()
                this.setState({ comprovante: false})
            } else {
                this.setState({ comprovante: false})
            }
        } catch(e) {
            this.setState({ comprovante: false})
        }
    }

    generateBtcReceipt = async (e)  => {
        var valor = e.quantiaBTC
        var fee = e.fee
        try {
            this.setState({ comprovante: true})
            const response = await request('wallet/getReceipt/', 'POST', {
                nome: e.favorecido,
                valor: parseFloat(valor).toFixed(8),
                fee: parseFloat(fee).toFixed(8),
                hash: e.hash,
                transactionId: e.transactionId,
                date: moment(e.date).format("DD/MM/YYYY HH:mm:ss")
            })
            if (response.code === 51) {
                let link = document.createElement('a')
                link.id = 'download-file'
                link.setAttribute('href', response.path);
                link.setAttribute('download', response.name);
                document.body.appendChild(link)
                document.querySelector('#download-file').click()
                document.getElementById('download-file').remove()
                this.setState({ comprovante: false})
            } else {
                this.setState({ comprovante: false})
            }
        } catch(e) {
            this.setState({ comprovante: false})
        }
    }

        render() {

            const { logged, userLogged, isLoading, details, success, userExpiration, loginExpired, walletLogged } = this.props
            return (
    
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : 
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.Linkpermissao === 4 ? <Redirect to="/minhaconta" /> :
                        <div className="section minhaContaWrapper">
                        <Container>
                                <div className="section">
                                    <Row>
                                        <Col md={12}>
                                            {/* <InsideMenu />     */}
                                        </Col>
                                    </Row>
                                </div>
                                <div className="section insideSec">
                                    <Row>
                                        <Col md={12} className="d-flex flex-column align-items-center">
                                            {/* MENSAGEM INICIAL */}
                                            {isLoading ? <center><Skeleton active title={{width: 350}} paragraph={false} /> </center> : <label className="statusName h4 detailsMobile">{this.returnMessage(details.type, details.status)}</label> }

                                            {/* ÍCONE */}
                                            {isLoading ? <center><Skeleton active avatar={{shape: 'square', size: '500px'}} title={false} paragraph={false} /></center> :
                                            <div className="wrapperIconDetalhe">
                                                {this.returnIcon(details.type, details.status)}
                                            </div> }

                                            {/* SUBTITULO */}
                                            {isLoading ? <center><Skeleton active title={{width: 350}} paragraph={false} /></center> :
                                            <label className="mt-5 transactionLabel">Valor {details.type === '1' || details.type === '5' ? 'enviado' : 'recebido'}</label> }

                                            {/* VALOR */}
                                            {isLoading ? <center><Skeleton active title={{width: 350}} paragraph={false} /></center> : this.returnValue(details.type, details) }

                                            
                                            <label className="mt-3 transactionLabel">Cálculo da transação</label>
                                            {/* TAXA */}
                                            {isLoading ? <center><Skeleton active title={{width: 350}} paragraph={false} /></center> : <small className="tx-blue font-weight-bold">Taxa: {details.type === '1' || details.type === '6' || details.type === '2' ? parseFloat(details.fee).toFixed(8)+' BTC*' : 'R$ '+this.formatarMoeda(parseFloat(details.fee/100).toFixed(2))} </small> }
                                            {details.type === '1' || details.type === '6' ? <small className="tx-blue font-weight-bold">*Taxa da rede Bitcoin.</small> : '' }
                                            {details.type === '1' && !details.status ? <small className="tx-blue font-weight-bold">Transação não confirmada. Ainda podem ocorrer alterações no valor da taxa.</small> : ''}

                                            {/* COTAÇÃO */}
                                            {details.type != '1' && details.type != '4' && details.type != '5' && details.type != '6' && details.type != '7' && !isLoading && (
                                                <center><small className="tx-blue font-weight-bold">Cotação no momento de execução da ordem: R$ {this.formatarMoeda(details.cotacao)}</small></center>
                                            )}

                                            {/* TOTAL CONVERTIDO */}
                                            {details.type != '1' && details.type != '4' && details.type != '5' && details.type != '6' &&  details.type != '7' && !isLoading ? 
                                                <small className="tx-blue font-weight-bold">Total convertido: {this.state.type === '2' ? details.quantiaBTC : 'R$ '+ this.formatarMoeda(details.quantiaBRL, 'totalConvertido')} {details.currency === 'BTC' ? '' : 'BTC'}</small> : ''
                                            }

                                            {/* TOTAL DA TRANSAÇÃO */}
                                            <label className="mt-3 transactionLabel">Total da transação</label>
                                            {isLoading ? <center><Skeleton active title={{width: 350}} paragraph={false} /></center> : <h3 className="tx-pink amount">{details.type === '1' || details.type === '6' || details.type === '2' ? (parseFloat(details.quantiaBTC) + parseFloat(details.fee)).toFixed(8) : 'R$ '+this.formatarMoeda((details.quantiaBRL/100 + details.fee/100).toFixed(2))}<span className="tx-blue mr-2"> {details.type === '1' || details.type === '6' ? 'BTC' : ''}</span></h3> }


                                            {/* HASH ID */}
                                            {details.type === '1' || details.type === '6' && !isLoading ? 
                                            <div>
                                                <center><label className="mt-3 transactionLabel">Transaction Hash</label></center>
                                                <label className="tx-blue big-text">{details.transactionId || 'Transação não confirmada'}</label>
                                            </div> : ''
                                            }

                                            {/* FAVORECIDO */}
                                            {details.type === '1' || details.type === '5' || details.type === '4' && details.favorecido.type === 'TRANSFER' && !isLoading ? 
                                                <div className="d-flex flex-column align-items-center w-50 mt-5" id='favorecidoMobile'>
                                                    <label className="transactionLabel mt-3 h4">Favorecido</label>
                                                    {details.type === '1' ? 
                                                    <h4 className="tx-pink big-text">{details.favorecido}</h4> :
                                                    <Favorecido favorecido={details.favorecido} /> }
                                                </div> 
                                            : '' }
                                            {this.state.comprovante ? <LoadingComponent /> :
                                            <div className="d-flex btnDetailWrapper justify-content-between mt-2" id='favorecidoMobile'>
                                                <Link to="/wallet/extrato" className="btnDetail btnDetailBack mt-3" id='favorecidoMobile' style={{width: details.type !== '5' && details.type !== '1' ? '100%' : '48%'}}>Voltar</Link>
                                                {details.type === '5' || details.type === '1' ?
                                                <Button style={{width:'48%'}} className="btnDetail btnDetailComprov mt-3" id='favorecidoMobile' onClick={details.type === '5' ? () => this.generateReceipt(details.favorecido) : () => this.generateBtcReceipt(details)}>Compartilhar comprovante</Button> : ''}
                                            </div> }
                                        </Col>
                                    </Row>
                                
                                </div>
                            </Container>
                        </div>                        
                    }
                    {/* <Footer /> */}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    isLoading: state.wallet_transactions.isLoading,
    details: state.wallet_transactions.details,
    success: state.wallet_transactions.success,
    userid: state.login.userid,
    userExpiration: state.wallet.userExpiration,
    walletLogged: state.wallet.walletLogged,
    loginExpired: state.wallet.loginExpired,
    idWallet: state.wallet.idWallet
})

const mapDispatchToProps = dispatch => ({
    onLoad: (id, type, idWallet) => {
        dispatch(loadTransactionDetails(id, type, idWallet))
    },
    loadUser: id => {
        dispatch(fetchUserInfo(id))
    },

})

export default connect(mapStateToProps, mapDispatchToProps)(DetalhesTransacao)